document.addEventListener('DOMContentLoaded', function () {
  var popup = document.querySelector('[data-popup-agreement]');
  if (!popup) return;

  var storageKey = popup.dataset.storageKey || 'popup_agreement_accepted';
  var alreadyAccepted = false;

  try {
    alreadyAccepted = window.localStorage.getItem(storageKey) === 'true';
  } catch (e) {
    alreadyAccepted = false;
  }

  if (alreadyAccepted) return;

  popup.hidden = false;
  document.body.classList.add('popup-agreement-lock');

  var acceptButton = popup.querySelector('[data-popup-agreement-accept]');
  if (acceptButton) {
    acceptButton.addEventListener('click', function () {
      try {
        window.localStorage.setItem(storageKey, 'true');
      } catch (e) {
        // localStorage unavailable (e.g. private browsing) — popup will
        // simply reappear next load in that case.
      }
      popup.hidden = true;
      document.body.classList.remove('popup-agreement-lock');
    });
  }
});